export default "__VITE_ASSET__BkDtbtyc__"